module.exports = __webpack_public_path__ + "static/media/bonos_white.7c427a6e.png";